module.exports = __webpack_public_path__ + "static/egyptian-fitted-sheet-white-1-1afb3221816932cfad5416a81c18a442.png";